import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { registerSW } from "virtual:pwa-register"
import App from "./App"
import { SessionProvider } from "./auth/SessionContext"
import { MenuDataProvider } from "./offline/MenuDataProvider"
import { lockBrowserControls } from "./browserControls"
import "./styles/global.css"

registerSW({ immediate: true })

// VITE_ALLOW_BROWSER_CONTROLS=true at start or build time keeps right-click and developer tools for testing.
if (import.meta.env.VITE_ALLOW_BROWSER_CONTROLS !== "true") lockBrowserControls()

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <MenuDataProvider>
          <App />
        </MenuDataProvider>
      </SessionProvider>
    </BrowserRouter>
  </React.StrictMode>
)
